import type {
  IGetSearchAggregatedEventsRequestParams,
  IGetSearchAggregatedEventsResponseBody,
  ISearchEntity,
} from "~/feature/search/type";
import { api } from "~/store/api";

const API_PREFIX = "/events";
const TRENDING_CACHE_SECONDS = 5 * 60;
const SEARCH_CACHE_SECONDS = 5 * 60;

const searchApi = api.injectEndpoints({
  endpoints: (builder) => ({
    getSearchEvents: builder.query<
      IGetSearchAggregatedEventsResponseBody,
      IGetSearchAggregatedEventsRequestParams
    >({
      query: (params) => ({
        url: `${API_PREFIX}/aggregated/search`,
        params,
      }),
      keepUnusedDataFor: SEARCH_CACHE_SECONDS,
    }),
    getSearchEntities: builder.query<ISearchEntity[], { query: string }>({
      query: (params) => ({
        url: "/search/entities",
        params,
      }),
    }),
    getSearchTrending: builder.query<string[], void>({
      query: () => ({ url: "/search/trending?window=7d" }),
      keepUnusedDataFor: TRENDING_CACHE_SECONDS,
    }),
    logSearchClick: builder.mutation<
      void,
      { query: string; clickedEventId: string; clickSource: "suggest" }
    >({
      query: (body) => ({
        url: "/search/click",
        method: "POST",
        body,
      }),
    }),
  }),
  overrideExisting: false,
});

export const {
  useLazyGetSearchEventsQuery,
  useLazyGetSearchEntitiesQuery,
  useGetSearchTrendingQuery,
  useLogSearchClickMutation,
} = searchApi;
